import Container from './LabelsBatchEdit.container';
import LabelsBatchEdit from './LabelsBatchEdit';

export default Container(LabelsBatchEdit);
